import { createApi } from '@reduxjs/toolkit/query/react';
import { queryRootConfig } from './http.service';

export const geographyApi = createApi({
  ...queryRootConfig,
  reducerPath: 'geographyApi',
  tagTypes: ['Province', 'Commune'],
  endpoints: (build) => ({
    getProvinces: build.query<
      { code: string; name: string; slug: string }[],
      void
    >({
      query: () => ({
        url: '/provinces',
      }),
      providesTags: ['Province'],
      transformResponse: (response: { data: any[] }) => {
        return response.data?.map((item) => ({
          code: item.code,
          name: item.name,
          slug: item.slug,
        })) || [];
      },
    }),

    getCommunesByProvinceId: build.query<
      { code: string; name: string }[],
      string
    >({
      query: (provinceId: string) => ({
        url: `/provinces/${provinceId}/communes`,
      }),
      providesTags: ['Commune'],
      transformResponse: (response: { data: any[] }) => {
        return response.data?.map((item) => ({
          code: item.code,
          name: item.name,
        })) || [];
      },
    }),
  }),
});

export const {
  useGetProvincesQuery,
  useLazyGetProvincesQuery,
  useGetCommunesByProvinceIdQuery,
  useLazyGetCommunesByProvinceIdQuery,
} = geographyApi;
